import { getSubAreas } from '../../../api/serverRequests';
import { handleCachedApiRequest } from '../../../utils/cacheUtils';

export default function SubAreaOptionsAPI(setSubAreaOptionsQuery, page, localKey, userId = null) {
	const transformSubAreas = (data) => {
		const subareasToProcess = data.subareas;
		return subareasToProcess.map((item) => ({
			label: item.Area,
			value: {
				full: item.subareafull,
				short: item.subareashort
			}
		}));
	};

	handleCachedApiRequest(
		getSubAreas,
		transformSubAreas,
		setSubAreaOptionsQuery,
		localKey,
		page,
		userId
	);
}
